import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BasePricingDetails } from './BasePricingDetails';

export class EMIInstallmentPricingDetails extends BasePricingDetails {
  readonly amountToBePaid: number;
  readonly amountToBePaidInLeastSubunit: number;
  readonly downPaymentAmountToBePaid: number;
  readonly downPaymentAmountToBePaidInLeastSubunit: number;
  readonly appliedNoOfMonths: number;
  readonly interestRateAmountToBePaid: number;
  readonly interestRateAmountToBePaidInLeastSubunit: number;

  constructor(productDetails: GetProductDetailsResponseType) {
    super(productDetails);

    const emiDetails =
      productDetails.product_purchase_details_for_user.pricing_details
        .emi_installment_details;

    this.downPaymentAmountToBePaid =
      emiDetails.down_payment_amount_to_be_paid || 0;
    this.downPaymentAmountToBePaidInLeastSubunit =
      emiDetails.down_payment_amount_to_be_paid_in_least_subunit || 0;
    this.amountToBePaid = this.downPaymentAmountToBePaid;
    this.amountToBePaidInLeastSubunit =
      this.downPaymentAmountToBePaidInLeastSubunit;
    this.appliedNoOfMonths = emiDetails.applied_no_of_months || 0;
    this.interestRateAmountToBePaid =
      emiDetails.interest_rate_amount_to_be_paid || 0;
    this.interestRateAmountToBePaidInLeastSubunit =
      emiDetails.interest_rate_amount_to_be_paid_in_least_subunit || 0;
  }

  get isEligibleForFreeProduct(): boolean {
    return this.amountToBePaid === 0;
  }
}
